// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpensesPage_container__1D8yF {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.ExpensesPage_title__h27o1 {
  color: rgb(151, 1, 14);
  font-family: "Ysabeau SC", sans-serif;
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.ExpensesPage_subtitle__o27gx {
  color: rgb(151, 1, 14);
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.5rem;
  margin: 2rem 0;
  text-align: center;
}

.ExpensesPage_formSection__1JwVA {
  margin-bottom: 1.5rem;
}

.ExpensesPage_label__0zDOH {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.ExpensesPage_input__FepTd {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s ease-in-out;
}

.ExpensesPage_input__FepTd:focus {
  border-color: rgb(151, 1, 14);
  outline: none;
}

.ExpensesPage_backButton__sjXhP {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.5rem;
  margin-bottom: 2rem;
  background-color: white;
  color: rgb(151, 1, 14);
  border: 2px solid rgb(151, 1, 14);
  border-radius: 8px;
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ExpensesPage_backButton__sjXhP:hover {
  background-color: rgb(151, 1, 14);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.ExpensesPage_submitButton__0iWkx {
  background-color: rgb(151, 1, 14);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 100%;
}

.ExpensesPage_submitButton__0iWkx:hover {
  background-color: rgb(121, 1, 11);
}

.ExpensesPage_deleteButton__xFfsB {
  background-color: #ff4444;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ExpensesPage_deleteButton__xFfsB:hover {
  background-color: #cc0000;
}

.ExpensesPage_tableContainer__7XI12 {
  overflow-x: auto;
  margin-top: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ExpensesPage_table__Kfgel {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.ExpensesPage_table__Kfgel th,
.ExpensesPage_table__Kfgel td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.ExpensesPage_table__Kfgel th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.ExpensesPage_error__rvALB {
  color: #ff4444;
  margin: 1rem 0;
  padding: 1rem;
  background-color: #ffe5e5;
  border-radius: 4px;
  text-align: center;
}

.ExpensesPage_loading__dj2uG {
  text-align: center;
  padding: 2rem;
  color: rgb(151, 1, 14);
  font-size: 1.2rem;
}

.ExpensesPage_retryButton__j8GdO {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.6rem 1.2rem;
  background-color: rgb(151, 1, 14);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.ExpensesPage_retryButton__j8GdO:hover {
  background-color: rgb(121, 1, 11);
}

.ExpensesPage_addExpenseSection__8BKxm {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.ExpensesPage_expensesSection__bSzaH {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .ExpensesPage_container__1D8yF {
    padding: 1rem;
  }

  .ExpensesPage_title__h27o1 {
    font-size: 1.5rem;
  }

  .ExpensesPage_subtitle__o27gx {
    font-size: 1.2rem;
  }

  .ExpensesPage_backButton__sjXhP {
    font-size: 1rem;
    padding: 0.6rem 1.2rem;
  }

  .ExpensesPage_addExpenseSection__8BKxm,
  .ExpensesPage_expensesSection__bSzaH {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/ExpensesPage/ExpensesPage.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.title {\n  color: rgb(151, 1, 14);\n  font-family: \"Ysabeau SC\", sans-serif;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.subtitle {\n  color: rgb(151, 1, 14);\n  font-family: \"Ysabeau SC\", sans-serif;\n  font-size: 1.5rem;\n  margin: 2rem 0;\n  text-align: center;\n}\n\n.formSection {\n  margin-bottom: 1.5rem;\n}\n\n.label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.input {\n  width: 100%;\n  padding: 0.8rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.2s ease-in-out;\n}\n\n.input:focus {\n  border-color: rgb(151, 1, 14);\n  outline: none;\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.8rem 1.5rem;\n  margin-bottom: 2rem;\n  background-color: white;\n  color: rgb(151, 1, 14);\n  border: 2px solid rgb(151, 1, 14);\n  border-radius: 8px;\n  font-family: \"Ysabeau SC\", sans-serif;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.backButton:hover {\n  background-color: rgb(151, 1, 14);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.submitButton {\n  background-color: rgb(151, 1, 14);\n  color: white;\n  border: none;\n  padding: 0.8rem 1.5rem;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n}\n\n.submitButton:hover {\n  background-color: rgb(121, 1, 11);\n}\n\n.deleteButton {\n  background-color: #ff4444;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.deleteButton:hover {\n  background-color: #cc0000;\n}\n\n.tableContainer {\n  overflow-x: auto;\n  margin-top: 2rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\n.table th,\n.table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n}\n\n.error {\n  color: #ff4444;\n  margin: 1rem 0;\n  padding: 1rem;\n  background-color: #ffe5e5;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.loading {\n  text-align: center;\n  padding: 2rem;\n  color: rgb(151, 1, 14);\n  font-size: 1.2rem;\n}\n\n.retryButton {\n  display: inline-block;\n  margin-top: 1rem;\n  padding: 0.6rem 1.2rem;\n  background-color: rgb(151, 1, 14);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.retryButton:hover {\n  background-color: rgb(121, 1, 11);\n}\n\n.addExpenseSection {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.expensesSection {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 1rem;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .subtitle {\n    font-size: 1.2rem;\n  }\n\n  .backButton {\n    font-size: 1rem;\n    padding: 0.6rem 1.2rem;\n  }\n\n  .addExpenseSection,\n  .expensesSection {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ExpensesPage_container__1D8yF`,
	"title": `ExpensesPage_title__h27o1`,
	"subtitle": `ExpensesPage_subtitle__o27gx`,
	"formSection": `ExpensesPage_formSection__1JwVA`,
	"label": `ExpensesPage_label__0zDOH`,
	"input": `ExpensesPage_input__FepTd`,
	"backButton": `ExpensesPage_backButton__sjXhP`,
	"submitButton": `ExpensesPage_submitButton__0iWkx`,
	"deleteButton": `ExpensesPage_deleteButton__xFfsB`,
	"tableContainer": `ExpensesPage_tableContainer__7XI12`,
	"table": `ExpensesPage_table__Kfgel`,
	"error": `ExpensesPage_error__rvALB`,
	"loading": `ExpensesPage_loading__dj2uG`,
	"retryButton": `ExpensesPage_retryButton__j8GdO`,
	"addExpenseSection": `ExpensesPage_addExpenseSection__8BKxm`,
	"expensesSection": `ExpensesPage_expensesSection__bSzaH`
};
export default ___CSS_LOADER_EXPORT___;
